import { Data2 } from "../../../../../features/data-types"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { DeliveryData } from "../../../../deliveries"
import { useHoardService } from "../../../services/hoardService"
import { HoardOrder, HoardType, SpecialDiscountItem } from "../../../state/types"

export const useActions = () => {
    const { getRoutePath } = useRoutesHooks()

    const { createHoard, updateHoard } = useHoardService()

    const submitHoard = async (
        data: Data2,
        branchId: string,
        itemsData: Data2[],
        hoardValue?: number,
        partialDeliveryData?: Partial<DeliveryData>,
        latePayment?: boolean,
        notes?: string,
        specialDiscountItems?: SpecialDiscountItem[],
        createMode?: boolean,
        keepItemsCustomerTypeYield?: boolean
    ) => {
        const { id, sellerId, customerId, customerTypeId, paymentTypeId, type, dueDate, internalNotes } = data
        const value = type === HoardType.FINANCIAL ? hoardValue : undefined
        const deliveryData = partialDeliveryData?.method ? {
            ...partialDeliveryData,
            method: partialDeliveryData.method
        } : undefined
        let hoardData: Data2 = {
            id,
            paymentTypeId,
            sellerId,
            customerId,
            customerTypeId,
            branchId,
            type,
            value,
            deliveryData,
            dueDate,
            latePayment,
            notes,
            internalNotes
        }

        let savedHoard: HoardOrder
        if (createMode) {
            savedHoard = await createHoard(hoardData, itemsData, specialDiscountItems, keepItemsCustomerTypeYield)
        } else {
            savedHoard = await updateHoard(hoardData, itemsData, specialDiscountItems)
        }

        Emitter.emit(Event.DB_SUBMIT_DONE, createMode, false, getRoutePath(RoutePath.HOARDS, savedHoard.id))
    }

    return {
        submitHoard
    }
}
